import { resolveCssVariable } from "@circle-react-shared/BuilderUI/ThemeConfiguration/SiteStyles/Tokens/utils/resolveCssVariable";

export const areRawValuesEqual = (
  existingValue: unknown,
  newValue: unknown,
  cssVariables: Record<string, string>,
): boolean => {
  if (
    typeof existingValue === "string" &&
    typeof newValue === "string" &&
    (existingValue.startsWith("var(--") || newValue.startsWith("var(--"))
  ) {
    const resolvedExisting = resolveCssVariable({
      value: existingValue,
      cssVariables,
    });
    const resolvedNew = resolveCssVariable({
      value: newValue,
      cssVariables,
    });
    return resolvedExisting === resolvedNew;
  }

  return existingValue === newValue;
};
